import React from "react";
import SearchIcon from "@mui/icons-material/Search";

const ListHeaderNoCard = ({
  title = "List",
  searchQuery,
  handleSearch,
  handleSearchChange,
  handleOpenCreateModal,
  children,
}) => {
  return (
    <div className="flex items-center justify-between mb-4 p-4">
      {/* Left side: Title */}
      <h2 className="text-2xl font-bold">{title}</h2>

      {/* Right side: Search + Buttons */}
      <div className="flex items-center space-x-4">
        {/* Search Input */}
        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
          <button
            onClick={handleSearch}
            className="px-3 py-2 text-gray-500 cursor-pointer border-r border-gray-300 bg-gray-50 hover:bg-gray-100 hover:text-sss-blue duration-500"
          >
            <SearchIcon />
          </button>
          <input
            type="text"
            className="px-3 py-2 w-full outline-none"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>

        {/* Optional extra children (e.g. Excel button) */}
        {children}

        {/* “Add” Button */}
        <button
          className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
          onClick={handleOpenCreateModal}
        >
          Add +
        </button>
      </div>
    </div>
  );
};

export default ListHeaderNoCard;
